import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  Input,
  OnInit,
  Signal,
  signal,
  WritableSignal
} from '@angular/core';
import { NgClass } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { MODAL_TOKEN, ModalProvider } from '@core';
import { SelectableMultiCheckboxModel } from './selectable-multi-checkbox.model';

@Component({
  selector: 'lib-selectable-multi-checkbox-modal',
  templateUrl: './selectable-multi-checkbox-modal.component.html',
  styleUrls: ['./selectable-multi-checkbox-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [IonicModule, NgClass]
})
export class SelectableMultiCheckboxModalComponent<T> implements OnInit {
  // Note: Using @Input() because component is used via Ionic modal componentProps
  @Input() header!: string;
  @Input() buttonText!: string;
  @Input() providedData!: SelectableMultiCheckboxModel<T>[];
  @Input() selectedData!: T[];
  @Input() requireSelection: boolean = false;

  private readonly modalProvider: ModalProvider = inject(MODAL_TOKEN);

  readonly providedDataSignal: WritableSignal<SelectableMultiCheckboxModel<T>[]> = signal<
    SelectableMultiCheckboxModel<T>[]
  >([]);
  readonly selectedDataSignal: WritableSignal<T[]> = signal<T[]>([]);

  readonly isConfirmDisabled: Signal<boolean> = computed(
    () => this.requireSelection && !this.selectedDataSignal()?.length
  );

  ngOnInit(): void {
    this.providedDataSignal.set(this.providedData);
    this.selectedDataSignal.set(this.selectedData);
  }

  isSelected(value: T): boolean {
    return this.selectedDataSignal()?.some((item: T) => item === value) ?? false;
  }

  selectItem(data: T): void {
    this.selectedDataSignal.update((selectedData: T[]) => {
      const isSelected: boolean = selectedData?.some((selectedItem: T) => selectedItem === data);

      if (isSelected) return selectedData.filter((selectedItem: T) => selectedItem !== data);

      return [...(selectedData || []), data];
    });
  }

  closeModal(): void {
    this.modalProvider.dismissModal$(this.selectedDataSignal());
  }
}
